import React from 'react';
interface ServiceCardProps {
  title: string;
  description: string;
  imageUrl: string;
}
function ServiceCard({
  title,
  description,
  imageUrl
}: ServiceCardProps) {
  return <div className="relative overflow-hidden rounded-xl group cursor-pointer h-64" data-id="element-173">
      {/* Background Image with Zoom Effect */}
      <div className="absolute inset-0 bg-cover bg-center transform group-hover:scale-110 transition-transform duration-500" style={{
      backgroundImage: `url(${imageUrl})`
    }} data-id="element-174" />
      {/* Dark Overlay */}
      <div className="absolute inset-0 bg-black/40 group-hover:bg-black/50 transition-colors" data-id="element-175" />
      {/* Content */}
      <div className="absolute inset-0 flex flex-col justify-end p-6" data-id="element-176">
        <h3 className="text-xl font-bold text-white mb-1" data-id="element-177">{title}</h3>
        <p className="text-white/80 text-sm" data-id="element-178">{description}</p>
      </div>
    </div>;
}
export function ServicesSection() {
  return <section id="services" className="bg-white py-20 px-4 sm:px-6 lg:px-8" data-id="element-179">
      <div className="max-w-7xl mx-auto" data-id="element-180">
        <div className="text-center mb-16" data-id="element-181">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-182">
            Commercial Cleaning Services
          </h2>
          <p className="text-gray-600 text-lg" data-id="element-183">
            Comprehensive solutions for every type of facility.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-184">
          <ServiceCard title="Office Cleaning" description="Daily and weekly cleaning for productive workspaces." imageUrl="https://images.unsplash.com/photo-1497215842964-222b430dc094?w=800" data-id="element-185" />
          <ServiceCard title="Floor Care & Maintenance" description="Stripping, waxing, buffing, and carpet extraction." imageUrl="https://images.unsplash.com/photo-1581578731548-c64695cc6952?w=800" data-id="element-186" />
          <ServiceCard title="Restroom Sanitation" description="Deep-clean protocols that exceed health standards." imageUrl="https://images.unsplash.com/photo-1552321554-5fefe8c9ef14?w=800" data-id="element-187" />
          <ServiceCard title="Window Cleaning" description="Interior and exterior glass, streak-free guaranteed." imageUrl="https://images.unsplash.com/photo-1527689368864-3a821dbccc34?w=800" data-id="element-188" />
          <ServiceCard title="Post-Construction Cleanup" description="Move-in ready spaces after any renovation or build." imageUrl="https://images.unsplash.com/photo-1504307651254-35680f356dfd?w=800" data-id="element-189" />
          <ServiceCard title="Janitorial Services" description="Full-service janitorial programs tailored to your facility." imageUrl="https://images.unsplash.com/photo-1556761175-5973dc0f32e7?w=800" data-id="element-190" />
        </div>
      </div>
    </section>;
}